import { NO_AVATAR_MESSAGE } from '@/constants/message'

/**
 * 遍历消息列表，进行分组
 * @param { Object[] } messageList
 * @returns { Number[][] }
 * @example
 *
 * return [
 *      [1, 1, 1],
 *      [2, 5, 5]
 * ]
 */
export default function group (messageList) {
    const result = []
    const messageListLength = messageList.length
    let i = 0
    while (i < messageListLength) {
        const groupStartIndex = findGroupStartIndex(messageList, i)

        if (groupStartIndex === null) {
            break
        }

        const groupEndIndex = findGroupEndIndex(
            messageList,
            groupStartIndex,
            messageList[groupStartIndex].baseProps.host
        )
        const groupAvatarIndex = findGroupAvatarIndex(
            messageList,
            groupStartIndex,
            groupEndIndex
        )

        i = groupEndIndex + 1

        result.push([groupStartIndex, groupEndIndex, groupAvatarIndex])
    }

    return result
}

function findGroupStartIndex (messageList, startIndex) {
    const messageListLength = messageList.length

    for (let i = startIndex; i < messageListLength; i++) {
        if (messageList[i].baseProps.host) {
            return i
        }
    }
    return null
}
function findGroupEndIndex (messageList, startIndex, host) {
    const messageListLength = messageList.length

    if (startIndex === messageListLength - 1) {
        return startIndex
    }
    for (let i = startIndex + 1; i < messageListLength; i++) {
        const messageHost = messageList[i].baseProps.host
        if (messageHost !== host) {
            return i - 1
        }
    }
    return messageListLength - 1
}

function findGroupAvatarIndex (messageList, startIndex, endIndex) {
    if (startIndex === endIndex) {
        return startIndex
    }

    let i = startIndex
    while (i <= endIndex) {
        const name = messageList[i].name
        if (NO_AVATAR_MESSAGE.includes(name)) {
            i++
        } else {
            break
        }
    }

    return i < endIndex
        ? startIndex
        : i
}
